var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletePopUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-pop-up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete-pop-up"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989445,8.66682402 L7.99972227,8.66682402 L7.99972227,16.6660463 C7.99972227,17.4019747 8.59699753,17.99925 9.33359258,17.99925 L14.6657408,17.99925 C15.4030025,17.99925 15.9989445,17.4019747 15.9989445,16.6660463 L15.9989445,8.66682402 M13.665838,5.99975 L10.3328288,5.99975 L9.66689351,6.66701846 L7.99972227,6.66701846 C7.63242464,6.66701846 7.33378701,6.96565609 7.33378701,7.33295371 L7.33378701,8.00022217 L16.666213,8.00022217 L16.666213,7.33295371 C16.666213,6.96565609 16.3675754,6.66701846 15.9989445,6.66701846 L14.3331065,6.66701846 L13.665838,5.99975",
    id: "Fill-3",
    fill: "#009846"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopUp);
export default __webpack_public_path__ + "static/media/delete-pop-up.ee05d5d1a09ac5bb53fc5450ca5791d8.svg";
export { ForwardRef as ReactComponent };